<template>
  <transition
    name="fade-shrink-in"
    appear
  >
    <div
      v-show="open"
      class="background-on-top p-8"
      style="background-color: hsla(0, 0%, 0%, .5); cursor: default"
      @click.self="close"
    >
      <div
        class="modal-dialog modal-lg mt-8"
        role="document"
        :data-backdrop="backdrop"
        :data-keyboard="keyboard"
      >
        <div class="modal-content">
          <div
            class="modal-header"
            style="color: white; vertical-align: middle"
            :style="{ 'background-color': color }"
          >
            <div class="bootstrap-dialog-header">
              <i
                v-if="canCloseModal"
                :title="trans('core.close')"
                class="fa fa-times"
                style="cursor: pointer; float:right"
                @click.stop="close"
              />

              <div class="bootstrap-dialog-title">
                <span style="display: inline-block; margin-top: 2px;">{{ title }}</span>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

// inspired by https://jsfiddle.net/xcoefffj/58/
// but without (portals)
export default {
  name: 'Modal',

  props: {
    open: {
      required: true,
    },
    title: {
      default: 'Title',
    },
    canCloseModal: {
      default: true,
      Boolean,
    },
    backdrop: {
      default: true,
    },
    keyboard: {
      default: true,
      Boolean,
    },
    color: {
      default: '#25167a !important',
    },
  },
  data () {
    return {}
  },
  created () {
    // listen to the escape key
    document.addEventListener('keydown', (e) => {
      if (this.open && e.keyCode == 27) {
        this.close()
      }
    })
  },
  methods: {
    close () {
      if (this.canCloseModal) {
        this.$emit('close')
      }
    },
  },

}
</script>

<style scoped>

    .fade-shrink-in-enter-active,
    .fade-shrink-in-leave-active {
        transition: all .3s ease;
    }

    .bootstrap-dialog-header{
        width:100%;
    }

    .fade-shrink-in-enter,
    .fade-shrink-in-leave-to {
        opacity: 0;
        transform: scale(1.1);
    }

    .background-on-top {
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 1026;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: auto;
    }

    .mt-8 {
        margin-top: 8rem !important;
    }

    *, ::after, ::before {
        border-width: 0;
        border-style: solid;
        border-color: #dae1e7;
    }

    *, ::after, ::before {
        box-sizing: inherit;
    }

</style>
